var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file modal组件
 * @author (zhaojun10)
 */

/* global document */

import React, { PureComponent } from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash-es';

import ModalBase from './ModalBase';
import { scrollWheel } from '../../common/util';

/*
 * 参数说明
 * visible            必需，是否弹出
 * children           必选，内容
 * onOk               必选，确认触发
 * onCancel           必选，取消触发
 * title              必选，标题
 * formFlag           必选，是否内含form，当用form组件时必需
 * width              必选，自定义宽度
 * className          必选，自定义class
 * buttonType         必选，button类型，0或者1
 * okText             必选，确认按钮文案
 * CancelText         必选，取消按钮文案
 * buttonReverse      必选，按钮是否左右换位置
 * type               可选，大型或者普通，"large"或者"normal"，默认"normal"
 * warningType        可选，是否为警示样式，布尔值
 */

var Modal = function (_PureComponent) {
    _inherits(Modal, _PureComponent);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        _this.close = function () {
            if (_this.div) {
                ReactDom.unmountComponentAtNode(_this.div);
                _this.div.parentNode === document.body && document.body.removeChild(_this.div);
                _this.isOpen = false;
            }
            scrollWheel.scrollEnable();
        };

        _this.renderCurrent = function (np) {
            !_this.div.parentNode && document.body.appendChild(_this.div);
            scrollWheel.scrollPrevent();
            _this.isOpen = true;
            ReactDom.render(React.createElement(ModalBase, np), _this.div);
        };

        _this.state = {
            visible: !!_this.props.visible
        };
        _this.div = document.createElement('div');
        _this.isOpen = !!_this.props.visible;
        return _this;
    }

    _createClass(Modal, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.isOpen) {
                this.close();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.state.visible && this.isOpen && this.renderCurrent(this.props);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (np.visible !== this.props.visible) {
                this.isOpen = !!np.visible;
                if (!np.visible) {
                    this.close();
                    return;
                }
                this.renderCurrent(np);
            }
            if (np.visible && !_.isEqual(np, this.props)) {
                this.renderCurrent(np);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return Modal;
}(PureComponent);

export default Modal;

Modal.propTypes = {
    visible: PropTypes.bool
};